import React, { ComponentType } from 'react';

import { useAuctionInsightData } from './use-auction-insight-data';
import { AuctionInsightDataProps, CompetitionCardWithAuctionDataProps } from '../utils/types';

export function withAuctionInsightData<P extends CompetitionCardWithAuctionDataProps>(WrappedComponent: ComponentType<P>) {
  const HoC = React.memo((props: Omit<P, keyof AuctionInsightDataProps>) => {
    const { dateRange } = props;
    const { data, isLoading } = useAuctionInsightData({
      dateRange,
    });

    return (<WrappedComponent
      {...props as any}
      data={data}
      isLoading={isLoading}
    />);
  });

  return HoC;
}
